import { render, staticRenderFns } from "./ConfiguracoesModulosPage.vue?vue&type=template&id=3500d3ac&scoped=true"
import script from "./ConfiguracoesModulosPage.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesModulosPage.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesModulosPage.vue?vue&type=style&index=0&id=3500d3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3500d3ac",
  null
  
)

export default component.exports